import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getParentId = async (codeParrainage: string): Promise<number | null> => {
    try {
        const parentResponse = await axios.get(`${API_URL}/user/parrainage?code=${codeParrainage}`);
        
        console.log('Réponse de récupération du parent :', parentResponse.data);

        const parentUserId = parentResponse.data.idParent;

        if (!parentUserId) {
            throw new Error('Code de parrainage invalide. Aucun utilisateur trouvé.');
        }

        return parentUserId;
    } catch (error) {
        if (axios.isAxiosError(error)) {
            throw new Error(error.response?.data.message || error.message);
        } else {
            throw new Error('Une erreur est survenue lors de la récupération de l\'ID du parent.');
        }
    }
};

export const registerUser = async (formData: any): Promise<any> => {
    
    try {
        let parentId: number | null = null;
        if (formData.code_parrainage) {
            parentId = await getParentId(formData.code_parrainage);
            console.log('Parent ID récupéré :', parentId);
        }

        formData.parent_id = parentId;

        console.log('Données du formulaire avant envoi :', formData);
        const response = await axios.post(`${API_URL}/user/register`, formData);
        console.log('Réponse de l\'API d\'inscription :', response.data);

        return response.data;
    } catch (error) {
        console.error('Erreur lors de l\'inscription :', error);

        if (axios.isAxiosError(error)) {
            if (error.response?.status === 400) {
                throw new Error('Mail déjà existant');
            }
            throw new Error(error.response?.data.message || error.message);
        } else {
            throw new Error('Une erreur est survenue lors de l\'inscription.');
        }
    }
};
export const getDirectory = async (page = 1, limit = 100, category?: string, city?: string) => {
  try {
    const params: any = { page, limit };
    if (category) params.category = category;
    if (city) params.city = city; 

    const response = await axios.get(`${API_URL}/user/directory`, { params });

    if (response.data.success) {
      return response.data; 
    } else {
      throw new Error(response.data.message || 'Erreur lors de la récupération de l\'annuaire');
    }
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message);
    } else {
      throw new Error('Une erreur est survenue lors de la récupération de l\'annuaire.');
    }
  }
};



export const getClientsWithOnlineStatusPaginated = async (
  paramsOrPage: any = { page: 1, limit: 100 },
  maybeLimit?: number
) => {
  try {
    // Support legacy call signature (page, limit) or a params object
    let params: any;
    if (typeof paramsOrPage === 'object') {
      params = paramsOrPage;
    } else {
      params = { page: paramsOrPage || 1, limit: maybeLimit || 100 };
    }

    const response = await axios.get(`${API_URL}/user/status-client`, { params });
    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.message);
    } else {
      throw new Error('Une erreur est survenue lors de la récupération des clients avec statut en ligne.');
    }
  }
}

export interface ConnectionStatsFilters {
  period?: string;
  from?: string;
  to?: string;
  userType?: string;
  status?: string;
}

export interface ConnectionStatsResponse {
  success: boolean;
  filters: {
    period: string;
    from: string;
    to: string;
    userType: string;
    status: string;
  };
  daily: Array<{
    date: string;
    connected: number;
    disconnected: number;
  }>;
  hourly: Array<{
    hour: number;
    label: string;
    connected: number;
  }>;
}

export const getConnectionStats = async (
  params: ConnectionStatsFilters = {}
): Promise<ConnectionStatsResponse> => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      throw new Error("Token non trouvé");
    }

    const response = await axios.get(`${API_URL}/user/connection-stats`, {
      params,
      headers: {
        'Authorization': `${token}`,
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error: any) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || error.response?.data?.error || error.message);
    }
    throw new Error('Une erreur est survenue lors de la récupération des statistiques de connexion.');
  }
}

// services/Registre_service.ts

interface DeleteAnonymousResponse {
  success: boolean;
  message: string;
  deletedCount: number;
  deletedUsers?: Array<{
    id: number;
    email: string;
    createdAt: string;
  }>;
}

export const deleteAnonymousUsers = async (
  userIds?: number | number[],
  deleteAll: boolean = false
): Promise<DeleteAnonymousResponse> => {
  try {
    const token = localStorage.getItem("token");
    
    if (!token) {
      throw new Error("Vous devez être connecté pour effectuer cette action");
    }

    // Validation
    if (!deleteAll && !userIds) {
      throw new Error("Veuillez spécifier les utilisateurs à supprimer");
    }

    // Construction de l'URL avec paramètre query si deleteAll
    const url = new URL(`${API_URL}/user/delete-anonymous-users`);
    if (deleteAll) {
      url.searchParams.append('deleteAll', 'true');
    }

    // Construction du corps de la requête
    const data: any = {};
    if (!deleteAll && userIds) {
      data.userIds = userIds;
    }

    console.log("🗑️ [DELETE ANONYMOUS] Requête:", {
      method: 'DELETE',
      url: url.toString(),
      deleteAll,
      userIds: userIds || 'tous',
      hasToken: !!token
    });

    const response = await axios.delete(url.toString(), {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      data
    });

    console.log("✅ [DELETE ANONYMOUS] Succès:", response.data);

    return response.data;

  } catch (error: any) {
    console.error("❌ [DELETE ANONYMOUS] Erreur détaillée:", {
      message: error.message,
      response: error.response?.data,
      status: error.response?.status
    });
    
    if (axios.isAxiosError(error)) {
      const errorMessage = error.response?.data?.message || 
                          error.message || 
                          'Erreur lors de la suppression';
      throw new Error(errorMessage);
    } else {
      throw new Error('Une erreur est survenue lors de la suppression des utilisateurs anonymes.');
    }
  }
};


/**
 * Supprimer un seul utilisateur anonyme
 */
export const deleteSingleAnonymousUser = async (userId: number): Promise<DeleteAnonymousResponse> => {
  return deleteAnonymousUsers(userId, false);
};

/**
 * Supprimer plusieurs utilisateurs anonymes
 */
export const deleteMultipleAnonymousUsers = async (userIds: number[]): Promise<DeleteAnonymousResponse> => {
  return deleteAnonymousUsers(userIds, false);
};

/**
 * Supprimer tous les utilisateurs anonymes
 */
export const deleteAllAnonymousUsers = async (): Promise<DeleteAnonymousResponse> => {
  return deleteAnonymousUsers(undefined, true);
};

